import React from "react";
import Head from "next/head";

const CustomHead = ({
  title,
  subTitle = "Պրոգնոզ",
  description = "Համակարգը հետևում է դրանց իրականացմանը և փոփոխում հեղինակների վարկանիշները։",
  path = "",
  id = "",
  poster = "https://firebasestorage.googleapis.com/v0/b/prognos-48733.firebasestorage.app/o/favicon.svg?alt=media&token=0716e573-ddb4-48c1-b948-cb8aaab5ad98",
}) => {
  const finalTitle = title || subTitle;
  const url = path ? `https://prognos.am/${path}/${id}` : "https://prognos.am";

  // Prepend domain for relative URLs to support social platform previews
  const finalPoster = poster?.startsWith("/")
    ? `https://prognos.am${poster}`
    : poster || "https://firebasestorage.googleapis.com/v0/b/prognos-48733.firebasestorage.app/o/favicon.svg?alt=media&token=0716e573-ddb4-48c1-b948-cb8aaab5ad98";

  // Clean description: strip HTML tags and truncate to standard ~160 chars
  const cleanDescription = (text) => {
    if (!text) return "";
    const noHtml = text.replace(/<[^>]*>/g, "");
    if (noHtml.length > 160) {
      return noHtml.substring(0, 157) + "...";
    }
    return noHtml;
  };
  const finalDescription = cleanDescription(description);

  return (
    <Head>
      {/* Basic */}
      <title key="title">{finalTitle}</title>
      <meta name="description" key="description" content={finalDescription} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" key="og:type" content="article" />
      <meta property="og:title" key="og:title" content={finalTitle} />
      <meta property="og:description" key="og:description" content={finalDescription} />
      <meta property="og:image" key="og:image" content={finalPoster} />
      <meta property="og:url" key="og:url" content={url} />
      <meta property="og:site_name" key="og:site_name" content="Prognos" />

      {/* Optional but recommended */}
      <meta property="og:image:width" key="og:image:width" content="1200" />
      <meta property="og:image:height" key="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" key="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" key="twitter:title" content={finalTitle} />
      <meta name="twitter:description" key="twitter:description" content={finalDescription} />
      <meta name="twitter:image" key="twitter:image" content={finalPoster} />
      <meta name="twitter:domain" key="twitter:domain" content="prognos.am" />
      <meta name="twitter:url" key="twitter:url" content={url} />
    </Head>
  );
};

export default CustomHead;
